import React from "react";
import SigninRegisterModal from "../../components/modal/signin-register-modal";
import { Swiper, SwiperSlide } from "swiper/react";
import { Mousewheel, Virtual } from "swiper/modules";
import "swiper/css";
import "swiper/css/virtual";
import AppFooterWeb from "../../components/AppFooterWeb";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  selectHomeData,
  selectFavoriteData,
  selectemployeeData,
} from "../../store/home/home.selectors";
import {
  favoriteSyncStart,
  homeSyncStart,
  resetFavorites,
  updateHomeSlideId,
} from "../../store/home/home.actions";
import AppConfig from "../../config/app.config";
import Banner from "../../components/banners/Banner";
import { Backdrop, CircularProgress } from "@mui/material";

const mapStateToProps = (state) => {
  return {
    favoriteData: selectFavoriteData(state),
    homeData: selectHomeData(state),
    employeeData: selectemployeeData(state),
  };
};

const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators(
    {
      favoriteSyncStart,
      resetFavorites,
      homeSyncStart,
      updateHomeSlideId,
    },
    dispatch
  ),
});

export class Favorites extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: 0,
      isSigninRegisterModalVisible: false,
      favoriteList: null,
    };
    this.swiper = null;
  }

  componentDidMount() {
    if (this.props.employeeData?.employeeId == null) {
      this.props.history.push("/");
    } else {
      window.scrollTo(0, 0);
      const payload = {
        appId: AppConfig.API.APP_ID,
        subscriptionId: AppConfig.API.SUBSCRIPTION_ID,
        verticalId: AppConfig.API.VERTICAL_ID,
        loginEmployeeId: this.props.employeeData?.employeeId,
        timeZone: Intl.DateTimeFormat()?.resolvedOptions()?.timeZone,
      };
      this.props.updateHomeSlideId(null);
      this.props.favoriteSyncStart(payload);
      this.setState({ isLoading: 1 });
    }
  }

  componentWillUnmount() {
    this.swiper = null;
    this.props.resetFavorites();
    this.props.updateHomeSlideId(null);
  }

  async componentDidUpdate(prevProps, prevState) {
    const { favoriteData } = this.props;
    if (favoriteData.favoriteList !== prevProps.favoriteData.favoriteList) {
      if (
        !favoriteData.syncingFavorite &&
        this.state.favoriteList !== favoriteData.favoriteList
      ) {
        this.setState(
          {
            favoriteList: favoriteData.favoriteList,
            isLoading: 0,
          },
          () => {
            if (this.swiper != null) {
              const projectId =
                this.state.favoriteList[this.swiper.activeIndex]?.projectId;
              this.props.updateHomeSlideId(
                projectId === "" ? null : projectId ?? null
              );
            }
          }
        );
      }
    }
    if (
      favoriteData.syncingFavorite !== prevProps.favoriteData.syncingFavorite
    ) {
      this.setState({
        isLoading: favoriteData.syncingFavorite ? 1 : 0,
      });
    }
  }

  render() {
    return (
      <div className="banner-section title-section">
        {this.state.isLoading === 1 && (
          <Backdrop style={{ zIndex: 9999999, color: "#fa96c8" }} open>
            <CircularProgress color="inherit" />
          </Backdrop>
        )}
        <div className="add-pagetitle">
          <p>My Favorites</p>
        </div>
        <Swiper
          autoHeight={true}
          direction={"vertical"}
          spaceBetween={0}
          mousewheel={{
            releaseOnEdges: true,
          }}
          virtual={{
            enabled: true,
            addSlidesAfter: 3,
            addSlidesBefore: 3,
          }}
          modules={[Mousewheel, Virtual]}
          className="mySwiper"
          onSwiper={(swiper) => {
            this.swiper = swiper;
            if (this.state.favoriteList != null) {
              const projectId =
                this.state.favoriteList[swiper.activeIndex]?.projectId;
              this.props.updateHomeSlideId(
                projectId === "" ? null : projectId ?? null
              );
            }
          }}
          id="swiperheader"
          onSlideChange={(swiper) => {
            const projectId =
              this.state.favoriteList[swiper.activeIndex]?.projectId;
            this.props.updateHomeSlideId(
              projectId === "" ? null : projectId ?? null
            );
          }}
        >
          {this.state.favoriteList != null &&
            this.state.favoriteList.map((banner, index) => {
              return (
                <SwiperSlide
                  className={index % 2 === 0 ? "left-banner" : "right-banner"}
                  key={banner?.projectId}
                  virtualIndex={index + 2}
                >
                  <Banner
                    bannerData={banner}
                    showSigninRegisterModal={() =>
                      this.setState({ isSigninRegisterModalVisible: true })
                    }
                  />
                </SwiperSlide>
              );
            })}
          <SwiperSlide
            id="footer-slide"
            className="hide-footersection"
            key={-1}
            virtualIndex={
              this.state.favoriteList != null
                ? this.state.favoriteList.length === 0
                  ? 0
                  : this.state.favoriteList.length + 1
                : 0
            }
          >
            <AppFooterWeb
              pathName={this.props.location?.pathname}
              history={this.props.history}
            />
          </SwiperSlide>
        </Swiper>

        <SigninRegisterModal
          show={this.state.isSigninRegisterModalVisible}
          hideModal={() =>
            this.setState({ isSigninRegisterModalVisible: false })
          }
        />
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Favorites);
